import MobileNav from "@/components/dashboard/longhouse/navigation/MobileNav";
import SidebarNav from "@/components/dashboard/longhouse/navigation/SidebarNav";
import TopNav from "@/components/dashboard/longhouse/navigation/TopNav";
import { navigationData } from "@/fixtures/navigationData";
import { useAuth } from "@/hooks/auth/useAuth";
import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";

const SUPERUSER_ONLY_PAGES = [
    "/longhouse/feature-flags",
    "/longhouse/twitch-connections",
    "/longhouse/tag-images",
    "/longhouse/background-tasks",
];

export default function LonghouseLayout() {
    const { user } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [navbarHeight, setNavbarHeight] = useState(0);
    const navbarRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const node = navbarRef.current;
        if (!node) return;

        const updateHeight = () => {
            const { height } = node.getBoundingClientRect();
            setNavbarHeight(height);
        };

        updateHeight(); // initial height
        const observer = new ResizeObserver(updateHeight);
        observer.observe(node);

        return () => observer.disconnect();
    }, []);

    const longhouseNavigation = navigationData.filter((item) => {
        if (SUPERUSER_ONLY_PAGES.includes(item.href)) {
            return Boolean(user?.isSuperuser);
        }
        return true;
    });

    return (
        <div
            className="flex h-screen bg-white dark:bg-slate-900"
            style={
                {
                    "--total-subtraction": `${navbarHeight + 4}px`,
                } as React.CSSProperties
            }
        >
            <MobileNav
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                navigation={longhouseNavigation}
            />
            <SidebarNav
                navigation={longhouseNavigation}
                collapsed={sidebarCollapsed}
            />
            <div className="flex min-w-0 flex-1 flex-col">
                <TopNav
                    setSidebarOpen={setSidebarOpen}
                    toggleSidebarCollapse={() =>
                        setSidebarCollapsed((prev) => !prev)
                    }
                    ref={navbarRef}
                    collapsed={sidebarCollapsed}
                />
                <main className="overflow-auto">
                    <div className="px-8 py-4">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}
